import classNames from 'classnames';
import React from 'react';
import MagneticWallItemAvatar from '../MagneticWallItemAvatar';
import styles from './CommentThreadCompactAvatar.module.scss';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';

const USER_FRAGMENT = gql(`
  fragment CommentThreadCompactAvatar_user on PublicUserFields {
    ...MagneticWallItemAvatar_user
  }
`);

interface CommentThreadCompactAvatarProps {
  ring?: boolean;
  user: DocumentType<typeof USER_FRAGMENT>;
}

const CommentThreadCompactAvatar = ({
  ring,
  user,
}: CommentThreadCompactAvatarProps) => (
  <div className={classNames(styles.avatar, { [styles.ring]: ring })}>
    <MagneticWallItemAvatar user={user} />
  </div>
);

export default CommentThreadCompactAvatar;
